export const textAreaTheme = {
  extend: {
    colorScheme: {
      light: {
        disabled: {
          background: '{sd.backgrounds.readonly}',
          color: '{sd.text.readonly}'
        }
      }
    }
  }
};
